import { render, staticRenderFns } from "./NewStuff.vue?vue&type=template&id=5a033076&"
import script from "./NewStuff.vue?vue&type=script&lang=js&"
export * from "./NewStuff.vue?vue&type=script&lang=js&"
import style0 from "./NewStuff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports